import { render } from "./DynamicHeadline.vue?vue&type=template&id=3eda3d28&scoped=true"
import script from "./DynamicHeadline.vue?vue&type=script&lang=js"
export * from "./DynamicHeadline.vue?vue&type=script&lang=js"

import "./DynamicHeadline.vue?vue&type=style&index=0&id=3eda3d28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eda3d28"]])

export default __exports__